import React from "react";
import Iconfont from "@components/iconfont/iconfont";
import "./index.less";

/**
 * 表单字段异常提醒，样式与 pc-login-modal 的字段报错保持一致。
 * 配合 antd Form.Item 的 help 使用：help={renderFieldError("fieldName")}
 */
export default function FormFieldError({ error, className }) {
  if (!error) return null;

  return (
    <span className={className ? `form-field-error ${className}` : "form-field-error"}>
      <Iconfont className="form-field-error-icon" type="icon-a-gantanhaoxi" />
      <span className="form-field-error-text">{error}</span>
    </span>
  );
}
